var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_979_1959)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 50.5,
    height: 50.5,
    rx: 25.25,
    stroke: "white",
    strokeWidth: 1.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 16.5C19.5 16.2239 19.7239 16 20 16H21.5C21.7761 16 22 16.2239 22 16.5V36.5C22 36.7761 21.7761 37 21.5 37H20C19.7239 37 19.5 36.7761 19.5 36.5V16.5ZM14 21.5C14 21.2239 14.2239 21 14.5 21H16C16.2761 21 16.5 21.2239 16.5 21.5V31.5C16.5 31.7761 16.2761 32 16 32H14.5C14.2239 32 14 31.7761 14 31.5V21.5ZM25.5 21C25.2239 21 25 21.2239 25 21.5V31.5C25 31.7761 25.2239 32 25.5 32H27C27.2761 32 27.5 31.7761 27.5 31.5V21.5C27.5 21.2239 27.2761 21 27 21H25.5ZM30.5 18.5C30.5 18.2239 30.7239 18 31 18H32.5C32.7761 18 33 18.2239 33 18.5V34.5C33 34.7761 32.7761 35 32.5 35H31C30.7239 35 30.5 34.7761 30.5 34.5V18.5ZM36.5 23C36.2239 23 36 23.2239 36 23.5V29.5C36 29.7761 36.2239 30 36.5 30H38C38.2761 30 38.5 29.7761 38.5 29.5V23.5C38.5 23.2239 38.2761 23 38 23H36.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_979_1959",
    x: -10,
    y: -10,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_979_1959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_979_1959",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPause);
export default __webpack_public_path__ + "static/media/ButtonPause.8c9158504c1b540a06f4a8c42916df50.svg";
export { ForwardRef as ReactComponent };